import { EditEmail } from "../../components/blackListEmail/EditEmail.component";
import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";

export const BlackListEmailEditPage = () => {
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column px-1 me-3">
          <p className="content-header">
            Blacklist Email Domain <BreadCrumbSign /> Update
          </p>
          <EditEmail />
        </div>
      </div>
    </div>
  );
};
